import React, {memo} from "react"
import style from "styles/tokenDistribution.module.css"
import useLocale from '../../../../hooks/useLocale'
import Main from '../../../content/components/Token/graphs/main'
import Mobile from '../../../content/components/Token/graphs/mobile'

const TokenDistribution = () => {
	const {tokenDistribution} = useLocale()

	return (
		<div
			data-aos-once="true"
			data-aos="slide-up"
			data-aos-offset="200"
			data-aos-easing="ease-in-sine"
			className={style.token}>
			<div className={style.container}>
				<h1 className={style.title}>{tokenDistribution.title}</h1>
				<h1 className={style.title}>{tokenDistribution.secondTitle}</h1>

				<img
					alt=""
					src="/image/token/token.jpg"
					data-aos-once="true"
					data-aos="fade-left"
					data-aos-offset="100"
					data-aos-easing="ease-in-sine"
				/>
			</div>
		</div>
	)
}

export default memo(TokenDistribution)
